import React, { useState, useEffect } from 'react';
import { CheckCircle, Sun, Clock, HandSoap, Info, Lightbulb, Article, Sparkle } from '@phosphor-icons/react';
import { useNavigate } from 'react-router-dom';

const SimpleRoutine = (props) => {
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(false);

  const displayData = props.routineData;
  console.log("[SimpleRoutine] Displaying data:", JSON.stringify(displayData, null, 2));

  useEffect(() => {
    if (displayData) {
      const timer = setTimeout(() => setIsVisible(true), 100);
      return () => clearTimeout(timer);
    }
  }, [displayData]);

  if (!displayData || Object.keys(displayData).length === 0) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin h-10 w-10 border-4 border-gray-300 border-t-indigo-600 rounded-full"></div>
        <p className="text-lg text-gray-500 ml-4">در حال بارگذاری اطلاعات روتین...</p>
      </div>
    );
  }

  const renderProduct = (product, type, stepIndex, prodIndex) => (
    <div key={`${type}-${stepIndex}-product-${prodIndex}`} className="bg-gray-50 rounded-lg p-3 border border-gray-200 text-sm">
      <div className="flex justify-between items-start mb-1">
        <h5 className="font-semibold text-gray-700">{product.name} <span className="text-xs text-gray-400">({product.brand})</span></h5>
        {/* {typeof product.match_score === 'number' && (
          <span className={`text-xs font-bold px-2 py-0.5 rounded-full ${product.match_score > 80 ? 'bg-green-100 text-green-700' : 'bg-yellow-100 text-yellow-700'}`}>
            {product.match_score}%
          </span>
        )} */}
      </div>
      {product.reason && <p className="text-xs text-gray-600 mt-1"><strong className="font-medium">چرا این محصول؟</strong> {product.reason}</p>}
      {product.how_to_use && <p className="text-xs text-gray-600 mt-1"><strong className="font-medium">روش استفاده:</strong> {product.how_to_use}</p>}
      {/* {product.link && <a href={product.link} target="_blank" rel="noopener noreferrer" className="text-xs text-blue-600 hover:text-blue-700 mt-2 inline-block">مشاهده محصول &rarr;</a>} */}
    </div>
  );

  const renderRoutineSection = (title, IconComponent, routineSteps, type, accentColor) => (
    routineSteps && routineSteps.length > 0 && (
      <div className={`bg-white rounded-xl shadow-lg p-4 md:p-6 border-t-4 ${accentColor}`}>
        <h2 className="text-xl font-semibold text-gray-800 mb-4 flex items-center">
          <IconComponent size={28} weight="duotone" className="mr-3" /> 
          {title}
        </h2>
        <div className="space-y-5">
          {routineSteps.map((step, index) => (
            <div key={`${type}-step-${index}`} className="pb-5 mb-5 border-b border-gray-200 last:border-b-0 last:pb-0 last:mb-0">
              <div className="flex items-center mb-3">
                <div className={`w-8 h-8 rounded-full ${type === 'morning' ? 'bg-yellow-100 text-yellow-700' : 'bg-indigo-100 text-indigo-700'} flex items-center justify-center flex-shrink-0 mr-3`}>
                  <span className="font-bold">{index + 1}</span>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-800">{step.title}</h3>
                  {step.description && <p className="text-xs text-gray-500">{step.description}</p>}
                </div>
              </div>
              {step.products && step.products.length > 0 && (
                <div className="mt-3 pl-11 space-y-3">
                  {step.products.map((product, prodIndex) => renderProduct(product, type, index, prodIndex))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    )
  );

  return (
    <main className={`flex-grow flex flex-col pt-6 bg-gray-100 min-h-screen transition-opacity duration-500 ease-out ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
      <div className="flex flex-col space-y-6 p-4 md:p-6 max-w-3xl mx-auto w-full">
        <div className="text-center pb-6">
          <div className="w-20 h-20 rounded-full bg-green-100 flex items-center justify-center mb-4 mx-auto shadow-lg border-4 border-white">
            <Sparkle size={48} weight="duotone" className="text-green-500" />
          </div>
          <h1 className="text-2xl md:text-3xl font-bold text-gray-800 mb-2">روتین پوستی اختصاصی شما</h1>
          <p className="text-gray-600">با Dermowise، پوستی سالم و درخشان داشته باشید!</p>
        </div>
        
        {displayData.analysis && (
          <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-200">
            <h2 className="text-xl font-semibold text-gray-800 mb-3 flex items-center"><Info size={24} className="mr-2 text-blue-500" />تحلیل وضعیت پوست شما:</h2>
            <p className="text-gray-700 leading-relaxed text-sm whitespace-pre-line">{displayData.analysis}</p>
          </div>
        )}
        
        {displayData.routine_plan && (
          <div className="bg-purple-50 rounded-xl p-5 border border-purple-100">
            <h2 className="text-xl font-bold text-gray-800 mb-3">برنامه فازبندی شده</h2>
            {typeof displayData.routine_plan === 'object' ? (
              Object.entries(displayData.routine_plan).map(([week, desc]) => (
                <div key={week} className="mb-2">
                  <strong>{week}:</strong> {desc}
                </div>
              ))
            ) : (
              <p className="text-gray-700 leading-relaxed text-sm whitespace-pre-line">{displayData.routine_plan}</p>
            )}
          </div>
        )}
        
        {renderRoutineSection("روتین صبحگاهی", Sun, displayData.morning_routine, "morning", "border-yellow-400")}
        {renderRoutineSection("روتین شبانگاهی", Clock, displayData.night_routine, "night", "border-indigo-400")}
        
        {displayData.skin_tips && displayData.skin_tips.length > 0 && (
          <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-200">
            <h2 className="text-xl font-semibold text-gray-800 mb-4 flex items-center">
              <Lightbulb size={28} weight="duotone" className="text-yellow-500 mr-3" />
              نکات کلیدی برای پوست شما:
            </h2>
            <ul className="space-y-3 text-sm text-gray-700">
              {displayData.skin_tips.map((tip, index) => (
                <li key={`tip-${index}`} className="flex items-start">
                  <CheckCircle size={18} weight="fill" className="text-green-500 mr-2 mt-1 flex-shrink-0" />
                  <span>{tip}</span>
                </li>
              ))}
            </ul>
          </div>
        )}
        
        <div className="space-y-3 pt-6 border-t border-gray-200 mt-2">
          <button 
            onClick={() => { navigate('/'); }}
            className="w-full bg-black text-white py-3 rounded-full font-semibold text-base hover:bg-gray-800 transition-colors"
          >
            بازگشت به صفحه اصلی
          </button>
          <button 
            onClick={() => window.print()}
            className="w-full flex items-center justify-center px-5 py-3 border border-gray-300 rounded-full text-sm text-gray-700 hover:bg-gray-100 transition-colors"
          >
            پرینت / ذخیره PDF
          </button>
        </div>
      </div>
    </main>
  );
};

export default SimpleRoutine; 